export const APP_NAME = "NotaViva";
export const APP_TAGLINE = "De tu voz a la nota clínica, en segundos.";
